import styled from 'styled-components';
import Input from 'src/components/atoms/input';

export const PrinterStationConfigWrapper = styled.div`
  margin-top: 24px;
`;

export const PrinterStationConfigPcIdInput = styled(Input)`
  && {
    width: 100%;
    margin-bottom: 16px;
  }
`;
